import { __rest } from "tslib";
import React from 'react';
import { Field } from 'formik';
import { Size } from '@vtblife/uikit/legacy';
import { notEmpty as notEmptyValidator, pipe, mayBeEmptyString } from '@vtblife/validators';
import { getValidator } from './get-validator';
import { isValueNotPresentInOptions } from './is-value-not-present-in-options';
export const createFormikComponent = (WrappedComponent, mapFunction, { errorValidator, warningValidator, optionsValueKey } = {}) => {
    const Component = props => {
        return React.createElement(WrappedComponent, Object.assign({}, mapFunction(props)));
    };
    return props => {
        const { required, template, validators = [], validate: validateFromProps, warningValidators = [], emptyOptionsAction, disabled, readOnly, mayBeEmpty } = props, restProps = __rest(props, ["required", "template", "validators", "validate", "warningValidators", "emptyOptionsAction", "disabled", "readOnly", "mayBeEmpty"]);
        const fieldValidators = validators;
        const shouldValidate = !(disabled || readOnly);
        if (required) {
            const notEmpty = typeof required === 'string' ? notEmptyValidator({ message: required }) : notEmptyValidator();
            fieldValidators.push(notEmpty);
            if (props.options && emptyOptionsAction === 'validate') {
                fieldValidators.push((value) => {
                    return isValueNotPresentInOptions(value, props.options, optionsValueKey)
                        ? 'Обязательное поле'
                        : undefined;
                });
            }
        }
        if (errorValidator) {
            fieldValidators.push(errorValidator);
        }
        if (template) {
            const validatorForTemplate = getValidator({ template });
            if (validatorForTemplate) {
                fieldValidators.push(validatorForTemplate);
            }
        }
        if (warningValidator) {
            warningValidators.push(warningValidator);
        }
        const validate = shouldValidate &&
            (validateFromProps ||
                (!required && mayBeEmpty ? mayBeEmptyString(...fieldValidators) : pipe(...fieldValidators)));
        const warningValidate = pipe(...warningValidators);
        return (React.createElement(Field, Object.assign({ validate: validate, size: Size.Large, fullWidth: true, warningValidator: warningValidate, template: template, emptyOptionsAction: emptyOptionsAction, required: required, disabled: disabled, readOnly: readOnly }, restProps, { component: Component })));
    };
};
//# sourceMappingURL=create-formik-component.js.map